<style lang="scss" src="./_scss/logo.scss"></style>
<template>
    <section class="mod_logo">
      <div v-if="isAmerican" class="logo is_American"></div>
      <div v-else-if="isIflix" class="logo is_iflix"></div>
      <div v-else class="logo normal"></div>
    </section>
</template>

<script type="text/ecmascript">
export default {
  data() {
    return {};
  },
  async created() {

  },
  async mounted() {

  },
  computed: {
    ...mapGetters(['isAmerican', 'isIflix']),
  },
  methods: {
  },
  components: {

  },
};
</script>
